<template>
  <w-modal
    v-model="show"
    :submit-button="$t('buttons.save')"
    :title="$t(title)"
    :close-button="$t('buttons.cancel')"
    :close-on-submit="false"
    :hideOnOverlay="false"
    :hideOnEsc="false"
    @submit="save()"
    @close="close()"
  >
    <div class="row">
      <div class="form-group col-md-12">
        <w-input :model="$schema.name" :title="$t($schema.name.$schema.title)" />
      </div>
    </div>
  </w-modal>
</template>

<script>
import { manageMixin } from '@/mixins/manage';
import schema from '@/schemas/sport.schema';

const emptyData = () => ({ name: '' });

// @vuese
// Modal dyscypliny
// @group Sport
export default {
  mixins: [manageMixin('sport', {}, emptyData)],
  schema,
  computed: {
    title() {
      return this.id ? 'modals.sport-edit' : 'modals.sport-add';
    }
  }
};
</script>